import searchFormReducer from "./slices/search-form";

export default {
  search_form: searchFormReducer
};
